export default "__VITE_ASSET__10a072b0__"